import React from 'react';
import {useIntl} from "react-intl";
import {shallowEqual, useSelector} from "react-redux";
import {StyledFieldDatepicker}  from "../../../_common/components/FieldDatepicker";
import {StyledFieldSelect} from "../../../_common/components/FieldSelect";
import {filterOptions} from "../../../_common/utils/options";
import {StyledFieldTextareaAutosize} from "../../../_common/components/FieldTextareaAutosize";
import {usePopupEditTasksContext} from "./PopupEditTasksContext";
import {taskStatuses} from "../../../_common/constants/options";
import ModalHeader from '../../../_common/components/ModalHeader';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ModalContent from '../../../_common/components/ModalContent';

export function TaskGeneral({header}) {
  const intl = useIntl();
  const prefix = 'tab-order-inspections-tasks-popup';
  const {formik} = usePopupEditTasksContext();
  const {values, setFieldValue} = formik;
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);
  const getFieldLabel = (text, mandatory = true) => {
    return (
      <div>
        <span>{text}</span>
        {mandatory && <span className={'text-danger'}>*</span>}
      </div>
    )
  };

  return (
    <>
      <ModalHeader header={header}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldTextareaAutosize
          fieldId={'taskDescription'}
          onChange={(e) => setFieldValue('taskDescription', e.target.value)}
          value={values.taskDescription}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-taskDescription`, defaultMessage: 'Task description'}))}
          customContainerStyles={'py-3'}
          customLabelStyles={'fs-6'}
        />
        <StyledFieldSelect
          fieldId={'responsibleUserID'}
          onChange={(option) => setFieldValue('responsibleUserID', option.value)}
          value={filterOptions(values.responsibleUserID)(users)}
          options={users}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-responsibleUser`, defaultMessage: 'Responsible user'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldDatepicker
          value={values.taskDueDate}
          onChange={(date) => setFieldValue('taskDueDate', new Date(date))}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldSelect
          fieldId={'taskStatusID'}
          onChange={(option) => setFieldValue('taskStatusID', option.value)}
          value={filterOptions(values.taskStatusID)(taskStatuses)}
          options={taskStatuses}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'}))}
          customContainerStyles={'py-3'}
        />
      </ModalContent>
    </>
  );
}

export default TaskGeneral;